/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RewardsDetailsEditor extends Common.GridEditorBase<RewardsDetailsRow> {
        protected getColumnsKey() { return "OMS.RewardsDetails"; }
        protected getDialogType() { return RewardsDetailsDialog; }
        protected getLocalTextPrefix() { return RewardsDetailsRow.localTextPrefix; }
        protected form: RewardsDetailsForm;

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();



        } 
        //protected getButtons(): Serenity.ToolButton[] {
        //    var buttons = super.getButtons();
        //    buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

        //    return buttons;
        //}
        validateEntity(row: RewardsDetailsRow, id) {
            //row.ProductID = Q.toId(row.ProductID);

            //var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ProductID === row.ProductID);
            //if (sameProduct && this.id(sameProduct) !== id) {
            //    Q.alert('This product is already in order details!');
            //    return false;
            //}
          

            // row.PromoName = PromotionMasterRow.getLookup().itemById[row.PromoId].PromoName;
            //row.= RewardsMasterRow.

            row.ProductTypeName = ProductTypeRow.getLookup().itemById[row.ProductTypeId].ProductTypeName
            row.CategoryName = CategoryMasterRow.getLookup().itemById[row.CategoryId].CategoryName
            row.SubCategoryName = SubCategoryMasterRow.getLookup().itemById[row.SubCategoryId].SubCategoryName

            //row.CompanyName = CompanyRow.getLookup().itemById[row.CompanyId].CompanyName;
            //row.FixedName = FixedCodeRow.getLookup().itemById[row.ProductTypeId].FixedName;
             // row.ProductTypeName = CommonAttributesRow.getLookup().itemById[row.ProductTypeId].ProductTypeName
           
            return true;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

    }
}